import { StoreApiService } from './storeApiService';

export class StoreCustomerService {
  private apiService = new StoreApiService();

  async loginWithPassword(email: string, password: string): Promise<void> {
    const data: Record<string, string> = {
      email: email,
      password: password,
    };

    await this.apiService.postJson('/auth/login', { data });
  }

  async autoLogin(email: string): Promise<void> {
    const data: Record<string, string> = {
      email: email,
      login_with_otp: '1',
    };

    await this.apiService.postJson('/auth/login', { data });
  }

  async logout(): Promise<void> {
    await this.apiService.postJson('/auth/logout');
  }
}
